import { useMutation } from '@tanstack/react-query';
import Api from '@/services/api';

interface ConsolidateParams {
	organization_id: string;
	company_id: string;
	file_id: string;
	id: string;
}

async function consolidate(params: ConsolidateParams): Promise<any> {
	const { id, ...payload } = params;
	const url = `/ergonomic-tool/owas/${id}/consolidate`;
	const { data } = await Api.post(url, payload);
	return data;
}

export const useConsolidateOWASReport = () => {
	return useMutation((payload: ConsolidateParams) => consolidate(payload));
};
